export const getUsersToNotifyWithoutCurrentUser = (usersToNotif, currentUserId) => {
  if (!Array.isArray(usersToNotif)) return []
  if (!currentUserId) return usersToNotif
  return usersToNotif.filter(user => !user.includes(currentUserId))
}

/**
 * Construit l'input de création d'un template de notification.
 *
 * Le contenu e-mail (`mailContent`) doit rester PARAMÉTRIQUE : il reprend le même template
 * que l'in-app (`event_template`, avec ses `{{placeholders}}`), pour être rempli avec les
 * variables de CHAQUE envoi côté backend (`replaceVariables`).
 *
 * On n'utilise volontairement PAS `data.email.event` : c'est une chaîne déjà interpolée
 * (nom de l'auteur, etc.) qui, le template étant créé une seule fois puis réutilisé, figerait
 * le contenu de l'e-mail sur les valeurs du tout premier envoi.
 *
 * Un e-mail peut être différent de l'in-app : si un cas fournit un `email_template`
 * (paramétrique) dédié, il est utilisé ; sinon on retombe sur `event_template` (e-mail = in-app).
 */
export const buildTemplateNotificationInput = payload => ({
  name: payload?.name_template,
  inAppContent: {
    infos: payload?.event_template,
    redirectUrl: payload?.redirectUrl_template,
  },
  mailContent: payload?.email_template ?? payload?.event_template,
})
